import { PromotionType } from '../../constants/promotion-type.js';
import { PROMOTION_CONSTRAINTS } from './constraints.js';
/** A Percentage Match promotion needs both percentages and a Product promotion needs a category. */
export function checkPromotionTypeRequirements(input) {
    if (input.type === PromotionType.PERCENTAGE_MATCH) {
        return ['brandPct', 'accountPct']
            .filter((field) => input[field] == null)
            .map((field) => ({
            path: [field],
            message: PROMOTION_CONSTRAINTS.messages.percentagesRequired,
        }));
    }
    if (input.type === PromotionType.PRODUCT && (input.categoryIds ?? []).length === 0) {
        return [{ path: ['categoryIds'], message: PROMOTION_CONSTRAINTS.messages.categoryRequired }];
    }
    return [];
}
//# sourceMappingURL=rules.js.map